import React from 'react';
import Head from 'next/head';
import { LandItTermsStyles } from './LandItTerms.styled';

const LandItTerms = () => {
  return (
    <LandItTermsStyles>
      <Head htmlAttributes={{ lang: 'en' }}>
        <title>Terms of Use | Clayton</title>
        <meta
          property="description"
          content="Terms of Use for Clayton's Find Land site."
        />
      </Head>
      <div className="terms-container">
        <h1>ListHub Platform Terms of Use</h1>
        <p>
          All standard terms of use apply. They can be viewed{' '}
          <a href="/legal">here</a>. In addition to those Terms, the following
          Terms of Use also apply. This platform is provided through a third
          party vendor. Information provided on the Platform may not be
          redistributed.
        </p>

        <p>
          YOU EXPRESSLY UNDERSTAND AND AGREE THAT: YOUR USE OF AND RELIANCE UPON
          ANY AND ALL OF THE LISTHUB NETWORK, SERVICES AND/OR CONTENT IS AT YOUR
          SOLE RISK AND IS MADE AVAILABLE ON AN “AS IS” AND “AS AVAILABLE”
          BASIS. MOVE MAKES NO EXPRESS OR IMPLIED REPRESENTATIONS, WARRANTIES,
          OR GUARANTEES WITH REGARD TO THE APPROPRIATENESS, ACCURACY,
          SUFFICIENCY, CORRECTNESS, VERACITY, VALUE, COMPLETENESS, OR TIMELINESS
          OF THE PLATFORM, SERVICES AND/OR CONTENT. WE EXPRESSLY DISCLAIM ALL
          WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT
          LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE AND NON-INFRINGEMENT.
        </p>

        <h3>Indemnification</h3>
        <p>
          YOU AGREE TO INDEMNIFY AND HOLD US, OUR THIRD-PARTY VENDORS, CORPORATE
          AFFILIATES, DIRECTORS, OFFICERS, EMPLOYEES AND AGENTS HARMLESS FROM
          ANY AND ALL CLAIMS AND DEMANDS, INCLUDING, BUT NOT LIMITED TO
          REASONABLE ATTORNEYS’ FEES, MADE BY ANY THIRD-PARTY DUE TO OR ARISING
          OUT OF ANY CONTENT, SUBMITTED, POSTED, OR OTHERWISE PROVIDED BY YOU TO
          THE US, THE PLATFORM AND/OR ITS OWNER AND/OR ITS THIRD PARTY
          ADVERTISERS AND ANY BREACH BY YOU OR YOUR AFFILIATES, EMPLOYEES,
          AGENTS AND REPRESENTATIVES OF THESE TERMS OF USE.
        </p>

        <h3>Limitation of Liability</h3>
        <p>
          IN NO EVENT SHALL WE BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE,
          INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER
          INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, DATA OR
          PROFITS, ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR
          PERFORMANCE OF THE PLATFORM, WITH THE DELAY OR INABILITY TO ACCESS OR
          USE THE PLATFORM OR RELATED SERVICES, THE PROVISION OF OR FAILURE TO
          PROVIDE SERVICES, OR FOR ANY CONTENT, SOFTWARE, PRODUCTS AND SERVICES
          MADE AVAILABLE OR OBTAINED THROUGH THE PLATFORM, OR OTHERWISE ARISING
          OUT OF THE USE OF THE PLATFORM, WHETHER BASED ON CONTRACT, TORT,
          NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, EVEN IF MOVE HAS BEEN
          ADVISED OF THE POSSIBILITY OF DAMAGES. ANY SERVICES OR CONTENT MADE
          AVAILABLE OR OBTAINED THROUGH THE USE OF THE PLATFORM, AND ALL OTHER
          USE OF THE PLATFORM, IS DONE AT YOUR OWN DISCRETION AND RISK AND YOU
          WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR
          LOSS OF DATA THAT RESULTS THEREFROM.
        </p>

        <p>
          IF YOU ARE DISSATISFIED WITH ANY PORTION OF THE PLATFORM, OR WITH ANY
          OF THESE TERMS OF USE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO
          DISCONTINUE USING THE PLATFORM.
        </p>
      </div>
    </LandItTermsStyles>
  );
};

export default LandItTerms;
